<template>
	<figure class="m-0">
		<div class="aspect-ratio-4-3 aspect-ratio-16-9-md m-0">
			<div
				v-for="(item, index) in filteredMediaItems"
				:key="index"
				class="media-gallery-preview__item"
				:style="computeStyle(index)"
				@click.stop="openModal(index)"
			>
				<div class="loader coterminous alpha" style="margin: auto"></div>
				<img
					v-lazy="item.thumbnailUrl"
					class="coterminous media-gallery-preview__item-bg-img"
					:alt="`gallery item ${index + 1}`"
				/>
				<div
					v-if="index === 3 && mediaItems.length > 4"
					class="media-gallery-preview__view-all-overlay coterminous delta gamma-md display-flex align-items-center justify-content-center"
				>
					<span class="text-color-white">View {{ mediaItems.length - 3 }} more</span>
				</div>
				<div
					v-if="!(index === 3 && mediaItems.length > 4)"
					class="media-gallery-preview__item-hover-overlay coterminous rounded"
				></div>
				<div
					v-if="
						item.mediaItemType === 'VIDEO' &&
						(mediaItems.length <= 3 || (mediaItems.length > 3 && index < 2))
					"
					class="play-button"
				></div>
			</div>
		</div>
		<figcaption v-if="props.caption" class="figcaption">{{ props.caption }}</figcaption>
	</figure>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { InvestorUpdateMediaItem } from 'types/account';
import MediaGalleryModal from '@components/account/media-gallery-modal.vue';
import { useAppStore } from '@stores/app';

interface Props {
	mediaItems: Array<InvestorUpdateMediaItem>;
	caption?: string;
	investorUpdateId?: string;
}

const props = withDefaults(defineProps<Props>(), {
	caption: '',
	investorUpdateId: ''
});

const appStore = useAppStore();

const indexToPosition: Record<number, Record<string, string>> = {
	0: {
		top: '0',
		left: '0'
	},
	1: {
		top: '0',
		right: '0'
	},
	2: {
		bottom: '0'
	},
	3: {
		bottom: '0'
	}
};

const numberOfItemsToStyle: Record<number, Record<number, Record<string, string>>> = {
	0: {
		1: {
			height: '100%',
			width: '100%'
		},
		2: {
			height: '100%',
			width: 'calc(50% - 1px)'
		},
		3: {
			height: '100%',
			width: 'calc(50% - 1px)'
		},
		4: {
			height: 'calc(50% - 1px)',
			width: 'calc(50% - 1px)'
		}
	},
	1: {
		2: {
			height: '100%',
			width: 'calc(50% - 1px)'
		},
		3: {
			height: 'calc(50% - 1px)',
			width: 'calc(50% - 1px)'
		},
		4: {
			height: 'calc(50% - 1px)',
			width: 'calc(50% - 1px)'
		}
	},
	2: {
		3: {
			right: '0',
			height: 'calc(50% - 1px)',
			width: 'calc(50% - 1px)'
		},
		4: {
			left: '0',
			height: 'calc(50% - 1px)',
			width: 'calc(50% - 1px)'
		}
	},
	3: {
		4: {
			right: '0',
			height: 'calc(50% - 1px)',
			width: 'calc(50% - 1px)'
		}
	}
};

const filteredMediaItems = computed((): Array<InvestorUpdateMediaItem> => props.mediaItems.slice(0, 4) ?? []);

function computeStyle(index: number): Record<string, string> {
	const computedStyle = {};
	const maxShow = props.mediaItems.length >= 4 ? 4 : props.mediaItems.length;
	Object.assign(computedStyle, indexToPosition[index]);
	Object.assign(computedStyle, numberOfItemsToStyle[index][maxShow]);

	return computedStyle;
}

function openModal(selectedIndex: number): void {
	appStore.updateCurrentModal({
		modal: MediaGalleryModal,
		props: {
			mediaItems: props.mediaItems,
			selected: selectedIndex,
			investorUpdateId: props.investorUpdateId
		}
	});
}
</script>
